export default [
  {
    component: 'CNavItem',
		to: '/employee',
		name: 'Employee Management',
		icon: 'cil-people',
  }
]
